import React, { useEffect } from "react"
import { StyledWidget } from "./partials"

export interface BBAWidgetProps {
  degree: string
  duration: string
}

export const BBAWidgetCmp: React.FC<BBAWidgetProps> = ({
  degree,
  duration,
}) => {
  useEffect(() => {
    const widgetScript = document.createElement("script")
    widgetScript.id = "unistats-widget-script"
    widgetScript.src = "//discoveruni.gov.uk/widget/embed-script"
    const scriptTags = document.getElementsByTagName("script")[0]

    if (!document.getElementById("unistats-widget-script")) {
      scriptTags.parentNode?.insertBefore(widgetScript, scriptTags)
    }

    return () => {
      const scriptElement = document.getElementById("unistats-widget-script")
      if (scriptElement) {
        scriptElement.remove()
      }
    }
  }, [])
  return (
    <StyledWidget>
      <div
        className="kis-widget"
        data-institution="10003212"
        data-course={degree}
        data-kismode={duration}
        data-orientation="responsive"
        data-language="en-GB"
      ></div>
    </StyledWidget>
  )
}
